import { render, staticRenderFns } from "./personal-center.vue?vue&type=template&id=1f1d56bf&scoped=true"
import script from "./personal-center.vue?vue&type=script&lang=ts"
export * from "./personal-center.vue?vue&type=script&lang=ts"
import style0 from "./personal-center.vue?vue&type=style&index=0&id=1f1d56bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1d56bf",
  null
  
)

export default component.exports